import LoadingView from "./LoadingView";
import PendingAccess from "./PendingAccess";
import { UserSettingKey } from "../constants/UserSettingKey";
import { linkToJob } from "../utils/linkTo";
import { useEffect } from "react";
import { useGetFacilitiesQuery } from "../slices/facilityApi";
import { useFacilities } from "../hooks/useFacilities";
import { useNavigate } from "react-router-dom";
import { useUserSetting } from "../hooks/useUserSetting";

/**
 * Redirect to the last facility user visited, or first facility user has access to.
 */
export default function MapLanding() {
  const facilities = useFacilities();
  const { isLoading } = useGetFacilitiesQuery();
  const navigate = useNavigate();
  const lastJobNumber = useUserSetting(UserSettingKey.JOB);

  // Redirect to first facility user has access to or display info page
  useEffect(() => {
    if (facilities && facilities.length > 0) {
      if (lastJobNumber) {
        navigate(linkToJob(lastJobNumber));
      } else {
        const facility = facilities[0];
        navigate(linkToJob(facility.jobNumber));
      }
    }
  }, [facilities, lastJobNumber, navigate]);

  // Show loading while facilities are being fetched
  if (isLoading) {
    return <LoadingView />;
  }

  // Show pending access message for new users with no facilities
  if (facilities && facilities.length === 0) {
    return <PendingAccess />;
  }

  return <></>;
}
